import React, { Component, Fragment } from 'react';
import Cookies from 'universal-cookie';
import cac_icon from './static/cac.png';
import yubikey_icon from './static/yubikey.png';
import cancel_icon from './static/cancel.png';

const cookies = new Cookies();

class Login extends Component {
  constructor(props) {
    super(props);
    var basic_grant = false;
    var cac_grant = false;
    var yubi_grant = false;
    /* If no cookie found then no methods are granted */
    var grant = cookies.get('oidc-authentication-methods');
    if (grant !== undefined) {
      basic_grant = 'authenticateByBasic' in grant && grant['authenticateByBasic'];
      cac_grant = 'authenticateByCAC' in grant && grant['authenticateByCAC'];
      yubi_grant = 'authenticateByYubikey' in grant && grant['authenticateByYubikey'];
    }
    /* For standalone testing append ' || true' to the grant */
    this.state = {
      cac_login: cac_grant,
      yubi_login: yubi_grant,
      basic_login: basic_grant,
      page_opts: cookies.get('oidc-authentication-ui') ||
        { "tokenName": 'CAC' }
    };
  }

  render() {
    var basicStyle = {
      fontSize: 80
    };

    var whatzIt = (
      this.state.page_opts["tokenName"]
    );

    var basicIcon = (
      <span aria-label="Basic Login" role="img" style={basicStyle}>&#x01F914;</span>
    );

    var basicMessage = (
      <Fragment>
        <div className="usa-grid choice-outline">
          <div className="usa-width-one-fourth auth-button">
            <button onClick={ this.props.onBasicLogin }>Basic Login</button>
          </div>
          <div className="usa-width-one-half">
            <p>Log in with your user name and password.</p>
          </div>
          <div className="usa-width-one-fourth auth-img">
            { basicIcon }
          </div>
        </div>
      </Fragment>
    );

    var cacMessage = (
      <Fragment>
        <div className="usa-grid choice-outline">
          <div className="usa-width-one-fourth auth-button">
            <button onClick={ this.props.onCACLogin }>{ whatzIt } Login</button>
          </div>
          <div className="usa-width-one-half">
            <p>Log in using PKI with { whatzIt }. Please select your PIV certificate. You
            will be asked to enter your { whatzIt } pin if it is not already cached in
            your browser.</p>
          </div>
          <div className="usa-width-one-fourth auth-img">
            <img src={cac_icon} alt="Common Access Card" />
          </div>
        </div>
      </Fragment>
    );

    var yubiMessage = (
      <Fragment>
        <div className="usa-grid choice-outline">
          <div className="usa-width-one-fourth auth-button">
            <button onClick={ this.props.onKRB5Login }>Yubikey Login</button>
          </div>
          <div className="usa-width-one-half">
            <p>Log in using Kerberos with Yubikey. You will be asked to enter
            your Kerberos principal, Kerberos password, and a Yubikey OTP.</p>
          </div>
          <div className="usa-width-one-fourth auth-img">
            <img src={yubikey_icon} alt="Yubikey" />
          </div>
        </div>
      </Fragment>
    );

    var cancelMessage = (
      <Fragment>
        <div className="usa-grid choice-outline">
          <div className="usa-width-one-fourth auth-button">
            <button className="usa-button-secondary" onClick={ this.props.onCancel }>Cancel</button>
          </div>
          <div className="usa-width-one-half">
            <p>Cancel the authentication process and return to your previous
            website.</p>
          </div>
          <div className="usa-width-one-fourth auth-img">
            <img src={cancel_icon} height="120px" alt="Cancel" />
          </div>
        </div>
      </Fragment>
    );

    var filler = (
        <div></div>
    );

    return (
      <div>
        <h3>Select HPCMP OpenID Connect Login Method</h3>
        { this.state.cac_login ? cacMessage : filler }
        { this.state.yubi_login ? yubiMessage : filler }
        { this.state.basic_login ? basicMessage : filler }
        { cancelMessage }
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/Login.jsx